import Navbar  from "../NavBar/NavBar.js";
import Footer from "../Home/Footer.js"
import Whatsapp from "../Home/Whatsapp.js";
import SA from "./groupe_pages/SA/SA.js"
import SA22 from "./groupe_pages/SA/SA22.js"
import SA33 from "./groupe_pages/SA/SA33.js"
import Spinner from "../../components/Home/Spinner.js";
import { useEffect } from "react";



const SolutionAcoustique = () => {
  useEffect(() => {
    // ✅ TITLE (SEO + local + conversion)
    document.title =
      "Acoustique Maroc | Panneaux & Feutrine Design – UNIK SYSTEM";

    // ✅ DESCRIPTION (CTR + mots clés + CTA)
    let metaDescription = document.querySelector("meta[name='description']");
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.setAttribute("name", "description");
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Solutions acoustiques au Maroc avec UNIK SYSTEM : panneaux acoustiques, feutrine décorative et correction phonique pour bureaux, hôtels et espaces professionnels. Devis gratuit."
    );

    // ✅ KEYWORDS
    let keywords = document.querySelector("meta[name='keywords']");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.setAttribute("name", "keywords");
      document.head.appendChild(keywords);
    }
    keywords.setAttribute(
      "content",
      "acoustique maroc, panneau acoustique maroc, feutrine acoustique maroc, mur acoustique decoratif, isolation phonique maroc, traitement acoustique maroc, tableau acoustique design"
    );

    // ✅ ROBOTS
    let robots = document.querySelector("meta[name='robots']");
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "index, follow");

    // ✅ CANONICAL
    let canonical = document.querySelector("link[rel='canonical']");
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute(
      "href",
      "https://unik-system.com/acoustique-maroc"
    );

    // ✅ OPEN GRAPH
    const setMetaProperty = (property, content) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    setMetaProperty(
      "og:title",
      "Solutions Acoustiques Maroc – UNIK SYSTEM"
    );
    setMetaProperty(
      "og:description",
      "Panneaux acoustiques et feutrine décorative pour améliorer le confort sonore au Maroc."
    );
    setMetaProperty(
      "og:image",
      "https://unik-system.com/static/media/US_LEVEL.bf16e3e163d5f8fff2a7.webp"
    );
    setMetaProperty(
      "og:url",
      "https://unik-system.com/acoustique-maroc"
    );
    setMetaProperty("og:type", "website");

    // ✅ TWITTER
    let twitterCard = document.querySelector("meta[name='twitter:card']");
    if (!twitterCard) {
      twitterCard = document.createElement("meta");
      twitterCard.setAttribute("name", "twitter:card");
      document.head.appendChild(twitterCard);
    }
    twitterCard.setAttribute("content", "summary_large_image");

    let twitterImage = document.querySelector("meta[name='twitter:image']");
    if (!twitterImage) {
      twitterImage = document.createElement("meta");
      twitterImage.setAttribute("name", "twitter:image");
      document.head.appendChild(twitterImage);
    }
    twitterImage.setAttribute(
      "content",
      "https://unik-system.com/static/media/US_LEVEL.bf16e3e163d5f8fff2a7.webp"
    );

  }, []);


    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SA/>
            <SA22/>
            <SA33/>
            <Footer/>
        </div>    
    )
};

export default SolutionAcoustique;
